import { AnalyticsEvent, AnalyticsEventName, AnalyticsProperties } from "../types";
import { mapTrackedOutcome, MutationTrackingState } from "../tracking";

type StaticMutationState = MutationTrackingState & {
  isLoading?: boolean;
  isUpdating?: boolean;
  isAdding?: boolean;
  isDeleting?: boolean;
  isResetting?: boolean;
  isContentUpdating?: boolean;
  isDefaultLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  error?: string;
  errorMessage?: string | null;
  message?: string;
  Message?: string;
  description?: string;
  Description?: string;
  ErrorMessage?: string;
  Reason?: string;
};

export const mapStaticMutation = (
  previousState: StaticMutationState | undefined,
  currentState: StaticMutationState | undefined,
  config: {
    successEventName?: AnalyticsEventName;
    errorEventName?: AnalyticsEventName;
    properties?: AnalyticsProperties;
    getSuccessEventName?: (state: StaticMutationState) => AnalyticsEventName | undefined;
    getErrorEventName?: (state: StaticMutationState) => AnalyticsEventName | undefined;
    getProperties?: (state: StaticMutationState) => AnalyticsProperties;
    trackedEventNames?: AnalyticsEventName[];
  }
): AnalyticsEvent[] => {
  if (!currentState?.lastRequestId) {
    return [];
  }

  const trackedEvents = mapTrackedOutcome(previousState, currentState, {
    successEventName: config.getSuccessEventName?.(currentState) || config.successEventName,
    errorEventName: config.getErrorEventName?.(currentState) || config.errorEventName,
    properties: {
      ...(config.properties || {}),
      ...(config.getProperties ? config.getProperties(currentState) : {})
    }
  });

  // Ambiguous shared reducers use trackingMeta to choose the concrete API outcome event.
  if (!config.trackedEventNames?.length) {
    return trackedEvents;
  }

  return trackedEvents.filter((event) => config.trackedEventNames?.includes(event.name));
};
